import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { translate } from "react-translate";
import AssetsList from 'components/Assets/AssetsList';

const Assets = (props) => {
  const {t} = props;
  
  return (
    <div className='content user-manual'>
      <Card>
        <CardHeader>
          <h5 className="title">{t("title-header")}</h5>
        </CardHeader>
        <CardBody>
          <AssetsList />
        </CardBody>
      </Card>
    </div>
  );
};

export default translate("assets")(Assets);
